import { IS_DISONA } from 'common/utils/style.util';

export const serverInfo = {
  type: '',
  provider: '',
  terminal_host: '',
  terminal_Port: '',
  name: '',
};
export const accountTypeInfo = {
  account_type: '',
  is_trading: true,
  currency: '',
  leverage: '',
};

export const accountInfo = {
  account_id: 0,
  account: '',
  name: '',
  account_type_info: accountTypeInfo,
  server_info: serverInfo,
  leverage: 0,
  balance: 0,
  equity: 0,
  margin: 0,
  free_margin: 0,
  archived: false,
  read_only: true,
  enable: true,
  is_swap_free: true,
};

export const openOrder = {
  type: 0, // Order type: Buy=0, Sell=1, BuyLimit=2, SellLimit=3, BuyStop=4, SellStop=5
  price: 0.0, // Order price
  volume: 0.0, // Trading volume in lots
  symbol: '', // Trading instrument, e.g. EURUSD
  deviation: 0, // Deviation
  sl: 0.0, // Stop Loss price; 0.0 by default
  tp: 0.0, // Take Profit price; 0.0 by default
  max_lost: 0.0, // Max Lost in account currency; 0.0 by default
  max_profit: 0.0, // Max Profit in account currency; 0.0 by default
  comment: '', // Optional comment on the order; its length can be up to 32 characters
};

export const modifyOrder = {
  ticket: 0, // Order number
  price: 0.0, // Order price
  volume: 0.0, // Price of a pending order;
  // if not planned to be changed,
  // the current value should be entered. 0.0
  // is used only when an open order is being updated
  sl: 0.0, // Stop Loss price; 0.0 by default
  tp: 0.0, // Take Profit price; 0.0 by default
};

export const closeOrder = {
  result: 0, // Trading response code
  ticket: 0, // Order number
  price: 0.0, // Closing price; it should be 0.0 to cancel a pending order
  volume: 0.0, // Closing trading volume in lots (it can differ from the requested one in case of partial execution)
  deviation: 0, // Deviation in case of Instant Execution
};

export const order = {
  comment: '',
  commission: 0,
  margin_rate: 0.0,
  price: 0.0,
  profit: 0.0,
  sl: 0.0,
  state: 0,
  swap: 0,
  symbol: '',
  ticket: 0,
  time_create: 0,
  time_update: 0,
  tp: 0.0,
  type: 0,
  volume: 1,
};

export const OrderTypes = {
  Buy: 0,
  Sell: 1,
  BuyLimit: 2,
  SellLimit: 3,
  BuyStop: 4,
  SellStop: 5,
};

export const CalcModes = {
  FOREX: 0,
  FOREX_NO_LEVERAGE: 5,
  CFD: 2,
  CFDLEVERAGE: 4,
};

const Green = '#15AA4F';
const Red = '#FF0E0F';

export const getType = (key) => {
  const types = {
    [OrderTypes.Buy]: { name: 'Buy', color: Green },
    [OrderTypes.Sell]: { name: 'Sell', color: Red },
    [OrderTypes.BuyLimit]: { name: 'BuyLimit', color: Green }, // order opens when price lower then current
    [OrderTypes.SellLimit]: { name: 'SellLimit', color: Red }, // order opens when price higher then current
    [OrderTypes.BuyStop]: { name: 'BuyStop', color: Green }, // order opens when price higher then current
    [OrderTypes.SellStop]: { name: 'SellStop', color: Red }, // order opens when price lower then current
    default: { name: '' },
  };

  const selectedType = types[key] || types.default;

  return {
    ...selectedType,
    key,
  };
};

const GreenDisona = '#00A4AF';
const RedDisona = '#D71A47';

export const getTypeDisona = (key) => {
  const types = {
    [OrderTypes.Buy]: { name: 'Buy', color: GreenDisona },
    [OrderTypes.Sell]: { name: 'Sell', color: RedDisona },
    [OrderTypes.BuyLimit]: { name: 'BuyLimit', color: GreenDisona }, // order opens when price lower then current
    [OrderTypes.SellLimit]: { name: 'SellLimit', color: RedDisona }, // order opens when price higher then current
    [OrderTypes.BuyStop]: { name: 'BuyStop', color: GreenDisona }, // order opens when price higher then current
    [OrderTypes.SellStop]: { name: 'SellStop', color: RedDisona }, // order opens when price lower then current
    default: { name: '' },
  };

  const selectedType = types[key] || types.default;

  return {
    ...selectedType,
    key,
  };
};

export const ServerType = {
  MT4: 'MT4',
  MT5: 'MT5',
};

export const MT_RET_REQUEST_DONE = {
  code: 10009,
  message: 'Request has been fulfilled',
};

export const FALLBACK_PARTNER = 'rock-west';

export const DISONA_PARTNER = 'disona';

export const DEALS_HISTORY_CONSTANTS = {
  dateFormat: 'DD.MM.YY',
  timeFormat: 'HH:mm:ss',
  farFutureDate: 89999999999999,
  dealsToFetchInitially: IS_DISONA ? 50 : 32,
  dealsToFetchOnScroll: IS_DISONA ? 20 : 5,
  scrollThreshold: 0.9,
};

export const ACCOUNT_TYPES_SWITCH = [
  { key: 'demo', value: 'Demo', label: 'DEMO' },
  { key: 'real', value: 'Real', label: 'REAL' },
  { key: 'all', value: 'All', label: 'ALL' },
];

export const DEMO_ACCOUNT_TYPE = 'Demo';
export const REAL_ACCOUNT_TYPE = 'Real';

export const MIN_DEPOSIT = 10;

export const INITIAL_DEMO_DEPOSIT = IS_DISONA ? 10000 : 1000;
export const RISK_MARKS = {
  0.1: 'low',
  0.25: 'medium',
  0.5: 'high',
  1: 'very high',
};

export const MAX_TRADING_REAL_ACCOUNTS = 2;
